import { render, staticRenderFns } from "./newslist.vue?vue&type=template&id=4b88ab3a&scoped=true&"
import script from "./newslist.vue?vue&type=script&lang=js&"
export * from "./newslist.vue?vue&type=script&lang=js&"
import style0 from "./newslist.vue?vue&type=style&index=0&id=4b88ab3a&lang=scss&scoped=true&"
import style1 from "./newslist.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b88ab3a",
  null
  
)

export default component.exports